module.exports = __webpack_public_path__ + "img/icon-news.28867601.svg";